import localforage from 'localforage';
import { AssetPortfolio, UpdateAssetPortfolioRequest } from '../type/AssetPortfolio.type';
import { v4 as uuidv4 } from 'uuid';
import { useAppStateLoadingCountStore } from '../../../common/store/AppStateStore.zustand';
import axios from 'axios';
import { SERVER_URL } from '../../../common/comstant/CommonConstants';

const assetPortfolioStore = localforage.createInstance({
  name: 'honeymoonsalad',
  storeName: 'assetPortfolioStore',
});

export const useAssetPortfolioStore = () => {
  const { addCount, minusCount } = useAppStateLoadingCountStore();

  const exportAssetPortfolioStore = async () => {
    if (!assetPortfolioStore) return;
    const keys = await assetPortfolioStore.keys();
    const entries = await Promise.all(
      keys.map(async (key) => ({ key, value: await assetPortfolioStore.getItem(key) })),
    );
    return entries;
    // const { data } = await axios.get<AssetPortfolio[]>(`${SERVER_URL}/asset-portfolio`);
    // return data.map((assetPortfolio) => ({ key: assetPortfolio.id, value: assetPortfolio }));
  };

  const importAssetPortfolioStore = async (entries: { key: string; value: unknown }[]) => {
    if (!assetPortfolioStore) return;

    await assetPortfolioStore.clear();
    await Promise.all(entries.map(({ key, value }) => assetPortfolioStore.setItem(key, value)));
    return true;
  };

  const clearAssetPortfolioStore = async () => {
    if (!assetPortfolioStore) return;

    await assetPortfolioStore.clear();
    return true;
  };

  const insertAssetPortfolioToStore = async (assetPortfolio: AssetPortfolio) => {
    if (!assetPortfolioStore) return { data: '' };
    addCount();

    const assetPortfolioId = uuidv4().toString();
    assetPortfolio.id = assetPortfolioId;
    assetPortfolio.componentList.forEach((item) => {
      item.id = uuidv4();
      item.assetPortfolioId = assetPortfolioId;
    });
    await assetPortfolioStore.setItem(assetPortfolioId, assetPortfolio);

    minusCount();
    return { data: assetPortfolioId };
  };

  const getAssetPortfolioListFromStore = async () => {
    if (!assetPortfolioStore) return { data: [] };
    addCount();

    const keys = await assetPortfolioStore.keys();
    const assetPortfolioList = await Promise.all(keys.map((key) => assetPortfolioStore.getItem<AssetPortfolio>(key)));

    minusCount();
    return { data: assetPortfolioList as AssetPortfolio[] };
  };

  const updateAssetPortfolioAtStore = async (id: string, updateAssetPortfolioRequest: UpdateAssetPortfolioRequest) => {
    if (!assetPortfolioStore) return { data: '' };
    addCount();

    updateAssetPortfolioRequest.componentList.forEach((item) => {
      if (!item.id) {
        item.id = uuidv4();
        item.assetPortfolioId = id;
      }
    });
    const assetPortfolio = await assetPortfolioStore.getItem<AssetPortfolio>(id);
    if (!assetPortfolio) return { data: '' };
    await assetPortfolioStore.setItem(id, {
      ...assetPortfolio,
      name: updateAssetPortfolioRequest.name,
      componentList: updateAssetPortfolioRequest.componentList,
    });

    minusCount();
    return { data: id };
  };

  const deleteAssetPortfolioAtStore = async (id: string) => {
    if (!assetPortfolioStore) return { data: '' };
    addCount();

    const assetPortfolio = await assetPortfolioStore.getItem<AssetPortfolio>(id);
    await assetPortfolioStore.removeItem(id);

    minusCount();
    return { data: assetPortfolio?.id ?? '' };
  };

  return {
    assetPortfolioStore,
    exportAssetPortfolioStore,
    importAssetPortfolioStore,
    clearAssetPortfolioStore,
    insertAssetPortfolioToStore,
    getAssetPortfolioListFromStore,
    updateAssetPortfolioAtStore,
    deleteAssetPortfolioAtStore,
  };
};
